module.exports = "/assets/data/3d2ccc080a761199dc2e5d5a9b021581-NE20.data.json";